import React from 'react';
import { Clock } from 'lucide-react';
import { getPlatformMeta, getActionMeta, formatMoney } from '../data/taskMeta';
import API_CONFIG from '../config/api';
import { useTranslation } from '../i18n/LocaleContext';

// GetLike task feed row: square cover, bold title, comma-separated tags, flat reward tag.
// Rendered as rows inside one bordered list container (divide-y), so no own card chrome.
const TaskCard = ({ task, onClick }) => {
  const { t } = useTranslation();
  const { label } = getPlatformMeta(task.platform);
  const { Icon: ActionIcon } = getActionMeta(task.actionType);

  const soldOut = task.remainingQuota <= 0;
  const limitReached = task.remainingForUser <= 0;
  const disabled = (soldOut || limitReached) && !task.inProgress;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center gap-3 text-left bg-white py-3 pl-4 pr-3.5 transition-colors
        ${disabled ? 'opacity-55' : 'active:bg-canvas'}`}
    >
      <span className="w-14 h-14 shrink-0 rounded-lg overflow-hidden ring-1 ring-black/[0.06]">
        <img
          src={API_CONFIG.getImageUrl(task.imageUrl)}
          alt={task.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </span>

      <span className="min-w-0 flex-1">
        <span className="text-[14px] font-bold text-ink leading-snug line-clamp-2 min-h-[40px]">{task.title}</span>
        <span className="mt-1 flex items-center gap-1.5 text-[12px] text-ink-muted">
          <ActionIcon className="w-3.5 h-3.5 shrink-0" />
          <span className="truncate">{task.category ? `${task.category}, ${label}` : label}</span>
          {!disabled && task.remainingQuota > 0 && (
            <span className="tabular shrink-0">{t('taskSlotsLeft', { n: task.remainingQuota })}</span>
          )}
        </span>
        {task.inProgress && (
          <span className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-brand-600">
            <Clock className="w-3 h-3" />{t('taskInProgress')}
          </span>
        )}
      </span>

      <span className={`shrink-0 rounded-lg px-3 py-1.5 text-[13px] font-bold tabular ${
        disabled ? 'bg-canvas text-ink-muted' : 'bg-brand-500 text-white'
      }`}>
        +{formatMoney(task.reward)}
      </span>
    </button>
  );
};

export default TaskCard;
